import { render, staticRenderFns } from "./SessionsHistoryDialog.vue?vue&type=template&id=8a2f9c4a"
import script from "./SessionsHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./SessionsHistoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports